<div *ngIf="loginDisplay" class="section-wrapper">
    <div class="main-grid-container">
        <!-- Employee Search Filter - Top Row -->
        <div class="employee-search-section">
            <form [formGroup]="form" class="employee-select-filter">
                <div class="search-title">Search Employees: </div>

                <!-- auto-completion for first name -->
                <mat-form-field>
                    <mat-label for="firstName">First Name</mat-label>
                    <input matInput type="search" formControlName="firstName" name="firstName" [matAutocomplete]="autoFirstName"/>
                    <mat-autocomplete #autoFirstName="matAutocomplete" panelWidth="auto" (optionSelected)="employeeSelected($event)">
                        <mat-option *ngIf="isLoadingEmployees" class="loading-option" disabled>
                            <div class="loading-content">
                                <mat-spinner diameter="20"></mat-spinner>
                                <span>Loading employees...</span>
                            </div>
                        </mat-option>
                        <mat-option *ngFor="let filteredEmployee of filteredEmployees" [value]="filteredEmployee">
                            {{filteredEmployee.firstName + " " + filteredEmployee.lastName + ": " +filteredEmployee.workEmail}}
                        </mat-option>
                    </mat-autocomplete>
                </mat-form-field>
                
                <mat-form-field>
                    <mat-label for="lastName">Last Name</mat-label>
                    <input matInput type="search" formControlName="lastName" name="lastName" [matAutocomplete]="autoLastName"/>
                    <mat-autocomplete #autoLastName="matAutocomplete" panelWidth="auto" (optionSelected)="employeeSelected($event)">
                        <mat-option *ngIf="isLoadingEmployees" class="loading-option" disabled>
                            <div class="loading-content">
                                <mat-spinner diameter="20"></mat-spinner>
                                <span>Loading employees...</span>
                            </div>
                        </mat-option>
                        <mat-option *ngFor="let filteredEmployee of filteredEmployees" [value]="filteredEmployee">
                            {{filteredEmployee.firstName + " " + filteredEmployee.lastName + ": " + filteredEmployee.workEmail}}
                        </mat-option>
                    </mat-autocomplete>
                </mat-form-field>

                <!-- auto-completion for work email -->
                <mat-form-field>
                    <mat-label for="workEmail">Work Email</mat-label>
                    <input matInput type="search" formControlName="workEmail" name="workEmail" [matAutocomplete]="autoWorkEmail" />
                    <mat-autocomplete #autoWorkEmail="matAutocomplete" panelWidth="auto" (optionSelected)="employeeSelected($event)">
                        <mat-option *ngIf="isLoadingEmployees" class="loading-option" disabled>
                            <div class="loading-content">
                                <mat-spinner diameter="20"></mat-spinner>
                                <span>Loading employees...</span>
                            </div>
                        </mat-option>
                        <mat-option *ngFor="let filteredEmployee of filteredEmployees" [value]="filteredEmployee">
                            {{filteredEmployee.workEmail}}
                        </mat-option>
                    </mat-autocomplete>
                </mat-form-field>

                <button mat-raised-button (click)="clearEmployeeSelected()">
                    <mat-icon>clear</mat-icon> 
                    <span>Clear Employee</span>
                </button>
            </form>
        </div>

        <!-- Image Uploader Section - Left Column -->
        <div class="photo-editor-section">
            <div 
                *ngIf="!isImageLoaded" 
                class="photo-cropper-container cropper-prompt-box"
                matRipple="true"
                [matRippleCentered]="true"
                (click)="fileUpload(fileInput)"
                >
                <p class="cropper-prompt-text-header">
                    <mat-icon class="chevron-left delay">chevron_right</mat-icon>
                    <mat-icon class="chevron-left">chevron_right</mat-icon>
                    CLICK HERE
                    <mat-icon class="chevron-right">chevron_left</mat-icon>
                    <mat-icon class="chevron-right delay">chevron_left</mat-icon>
                </p>
                <p>
                    To Select A Photo
                </p>
            </div>

            <image-cropper 
                class="cropper" 
                format="jpeg"
                alignImage="center"
                (imageCropped)="imageCropped($event)" 
                (imageLoaded)="imageLoaded($event)"
                (loadImageFailed)="loadImageFailed()"
                [imageChangedEvent]="imageChangedEvent"
                [maintainAspectRatio]="true" 
                [style.display]="isImageLoaded ? 'flex' : 'none'"
                [transform]="transform"
                >
            </image-cropper>

            <div class="photo-edit-controls">
                <button mat-raised-button (click)="fileClear()">
                    <mat-icon>clear</mat-icon> 
                    Clear Photo
                </button>
                <button mat-raised-button (click)="imageRotate()">
                    <mat-icon>rotate_left</mat-icon> Rotate
                </button>
            </div>
        </div>

        <!-- Photo Utility Section - Right Column -->        
         <div class="photo-utility-section">
            <div class="image-preview-container">
                <div class="image-preview-wrapper skeleton-box preview-ec round-image">
                    <img 
                        class="image-preview" 
                        [style.visibility]="isImageLoaded ? 'visible' : 'hidden'"
                        [src]="resizedImageECBase64" 
                        title="Round Preview - How Photo Appears in SuccessFactors/Employee Central" />                    
                        
                    <div *ngIf="showAlignmentGuide" class="person-overlay" [class.dark-overlay]="isDarkOverlay" [class.light-overlay]="!isDarkOverlay">
                        <img src="assets/images/person.svg" alt="Person placeholder" class="person-icon" />
                    </div>
                </div>
                <mat-slide-toggle [(ngModel)]="showAlignmentGuide" color="primary">
                    Show Guide
                </mat-slide-toggle>                
            </div>            
            
            <div class="current-employee-card-container" style.visibility="{{selectedEmployee ? 'visible' : 'hidden'}}">
                <div style.visibility="{{selectedEmployee ? 'visible' : 'hidden'}}">
                    <div class="current-employee-data"> UPLOAD FOR EMPLOYEE: </div>
                    <div class="current-employee-data">{{selectedEmployee?.fullName}}</div>
                    <div class="current-employee-data">{{selectedEmployee?.workEmail}}</div>
                    <div class="current-employee-data">District {{selectedEmployee?.districtNumber}} -- {{selectedEmployeeDistrictName}}</div>
                </div>
            </div>

            <button (click)="uploadImage()" mat-raised-button color="primary" [disabled]="!isImageLoaded || !selectedEmployee" class="upload-button">
                    <mat-icon>cloud_upload</mat-icon> 
                    <span>Upload</span> 
            </button>
        </div>
    </div>

    <input 
        type="file" 
        (change)="fileChangeEvent($event)" 
        (click)="fileUploadOnClick($event)" 
        #fileInput 
        id="file-input" />
</div>
